import { render, staticRenderFns } from "./ClaimsReportedByChart.vue?vue&type=template&id=5dd05f4f&scoped=true"
import script from "./ClaimsReportedByChart.vue?vue&type=script&lang=js"
export * from "./ClaimsReportedByChart.vue?vue&type=script&lang=js"
import style0 from "./ClaimsReportedByChart.vue?vue&type=style&index=0&id=5dd05f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd05f4f",
  null
  
)

export default component.exports